import {
  CONTENT_QUERY_PARAM_NAME,
  EIndexContent,
  INDEX_PATH,
} from 'routes/constants';
import { Redirect, useHistory } from 'react-router';

import { AccountPermission } from 'modules/permissions/constants';
import { RedirectAfterLogin } from 'modules/auth/components/RedirectAfterLogin';
import { projectsRoutesConfig } from 'domains/projects/routes';
import { selectCanContinueTeamCreationFlow } from 'modules/teams/store/selectors';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';
import { useSignOut } from 'modules/auth/hooks/useSignOut';
import { useTFA } from 'modules/tfa/hooks/useTFA';

const projectsPath = projectsRoutesConfig.projects.generatePath();

export const RedirectHandler = () => {
  const { callback, isLoggedIn } = useAuth();
  const { isAccountInitialized } = useAccount();
  const { location } = useHistory();
  const { isTFADialogOpened } = useTFA();

  const { isSigningOut } = useSignOut();

  const hasAccessToProjects = useCheckAccountPermission({
    permission: AccountPermission.JwtManagerRead,
  });

  const shouldRedirectToSettings = useAppSelector(
    selectCanContinueTeamCreationFlow,
  );

  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  const shouldRedirectToCallback =
    isLoggedIn &&
    isAccountInitialized &&
    Boolean(callback.redirectURL) &&
    !isTFADialogOpened &&
    !isPartnerClient &&
    !isPartnerStatusLoading;

  if (shouldRedirectToCallback) {
    return <RedirectAfterLogin to={callback.redirectURL!} />;
  }

  const params = new URLSearchParams(location.search);
  const isIndexPath = location.pathname === INDEX_PATH;

  const hasEndpointsContent = params.has(
    CONTENT_QUERY_PARAM_NAME,
    EIndexContent.Endpoints,
  );

  const shouldRedirectToProjects =
    isLoggedIn &&
    hasAccessToProjects &&
    !hasEndpointsContent &&
    isIndexPath &&
    !shouldRedirectToSettings &&
    !isSigningOut;

  if (shouldRedirectToProjects) {
    return <Redirect to={projectsPath} />;
  }

  return null;
};
